import * as React from "react";
import { Dropdown, Grid, Menu } from "semantic-ui-react";

import * as DTO from "../../../interfaces";
import { useCategories } from "../../../utils";

import { CampaignServices } from "../../../services";
import { SearchComponent, CampaignsSection } from "../../../components";

import "./styles.scss";
import { CampaignsSearchList } from "./components/CampaignsSearchList";
import { useMemo } from "react";
import { CategoryCards } from "./components/CategoryCards";

interface OwnProps {
  coachId: string;
}

type Props = OwnProps;

const CampaignsByCategoryFC: React.FC<Props> = ({ coachId }) => {
  const [searchedCampaignList, setSearchedCampaignList] = React.useState<DTO.CampaignResume[]>([]);
  const [searchActive, setSearchActive] = React.useState<boolean>(false);
  const [viewType, setViewType] = React.useState<"LIST" | "CARD">(
    localStorage.getItem("campaignViewType") == "CARD" ? "CARD" : "LIST"
  );

  const { categories, categoryOptions } = useCategories("CAMPAIGN");

  const content = useMemo(() => {
    if (viewType == "LIST") {
      return searchActive ? (
        <CampaignsSearchList categories={categories} campaignList={searchedCampaignList} coachId={coachId} />
      ) : (
        <CampaignsSection categories={categories} coachId={coachId} />
      );
    } else {
      return <CategoryCards categories={categories} campaignList={searchedCampaignList} coachId={coachId} />;
    }
  }, [viewType, categories, searchedCampaignList, coachId, searchActive]);

  return (
    <Grid className={"campaignListComponentContainer"} data-elm-id="campaignListComponent">
      <Grid.Row>
        <Grid.Column>
          <SearchComponent
            cacheKey={"coachCampaigns"}
            refreshData={setSearchedCampaignList}
            refreshAllDataToExport={result => {
              if (result) {
                setSearchedCampaignList(() => result!);
              } else {
                setSearchedCampaignList(() => []);
              }
            }}
            hideWhenNotSearch={true}
            filterPlaceholder={"Filter by categories"}
            customSize={50}
            content={content}
            additionalFilterContent={
              <Menu.Item>
                <Dropdown
                  selection
                  placeholder={"View Type"}
                  className="searchInput"
                  selectOnBlur={false}
                  onChange={(_, data) => {
                    localStorage.setItem("campaignViewType", data.value as "LIST" | "CARD");
                    setViewType(data.value as "LIST" | "CARD");
                  }}
                  value={viewType}
                  options={[
                    { text: "List View", value: "LIST", icon: "list" },
                    { text: "Card View", value: "CARD", icon: "block layout" },
                  ]}
                />
              </Menu.Item>
            }
            searchFunction={CampaignServices.searchCampaigns}
            showSortBy={false}
            filters={categoryOptions}
            pageable={false}
            onSearchedHandler={setSearchActive}
          />

          {categories && !searchActive && content}
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
};

export const CampaignListContent = CampaignsByCategoryFC;
